export default '/build/680daaac.svg'